<meta name="viewport" content="width=device-width, initial-scale=1.0">
<mat-tab-group>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>Ajouter un sinistre</span>
        </ng-template>
        <div class="o-hidden mt-4" *ngIf="Formcar" style="margin:20px">
            <form [formGroup]="Formcar" autocomplete="off">
                <h4> 1- Déclaration du Sinistre</h4>
                <div fxLayout="row wrap" style="margin-top:20px">
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <app-search-adresse-actuel (newItemEvent)="addItemAct($event)"></app-search-adresse-actuel>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <app-search-adresse-accident (newItemEvent)="addItemAcc($event)"></app-search-adresse-accident>
                    </div>
                </div>
                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                    <mat-form-field fxFlex="100" fxFlex.gt-sm="50" class="px-3" appearance="fill">
                        <mat-label>Vehicule</mat-label>
                        <mat-select placeholder="choisir un vehicule" formControlName="vehicule" (selectionChange)="resevationVehicule()" required>
                            <mat-option *ngFor="let item of Car" [value]="item.id">
                                {{item.vehicle_mark}},{{item.vehicle_model}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="Formcar.controls.vehicule.errors?.required">veillez choisir une date svp
                        </mat-error>  
                    </mat-form-field>
                    <mat-form-field fxFlex="100" fxFlex.gt-sm="50" class="px-3" appearance="fill">
                        <mat-label>Reservation</mat-label>
                        <mat-select placeholder="choisir un vehicule" name="reservation" formControlName="reservation" required (selectionChange)="choiseRenting()">
                            <mat-option>
                                <span style="margin-right:5px;font-weight: bloder" *ngIf="idVehicule">Date de départ</span>
                                <span style="margin-left:25px;font-weight: bloder" *ngIf="idVehicule">Date de retour </span>
                                <span *ngIf="idVehicule == null || idVehicule == undefined">Veillez selectionner un véhicule</span>
                            </mat-option>
                            <mat-option *ngFor="let reservation of rentings" [value]="reservation.id">
                                <span style="margin-right:5px">{{reservation.renting_date_departure
                                    |date:'mediumDate'}}</span>
                                <span style="margin-left:26px">{{reservation.renting_date_return |date:'mediumDate'}}
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-hint>Champs Obligatoire *</mat-hint>
                        <mat-error *ngIf="Formcar.controls.reservation.errors?.required">
                            <span>Ce champs est obligatoire</span>
                            <span>veillez choisir un un vehicule</span>
                        </mat-error>  
                    </mat-form-field> 
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">                 
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Date de l'accident'</mat-label>
                            <input matInput formControlName="date_acc" [matDatepicker]="picker5" [min]="minDate" [max]="maxDate"
                                required>
                            <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                            <mat-datepicker #picker5></mat-datepicker>
                            <mat-error *ngIf="Formcar.controls.date_acc.errors?.required">veillez choisir une date svp
                            </mat-error>  
                        </mat-form-field>                               
                    </div>
                    <div  fxFlex="100" fxFlex.gt-sm="50" class="px-3" > 
                        <mat-form-field  appearance="fill" class="w-100">
                        <mat-label>Heure</mat-label>
                        <mat-select formControlName="heureSinistre" required>
                            <mat-option   *ngFor="let hourss of hoursObj" [value]="hourss.name">
                            {{hourss.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="Formcar.controls.heureSinistre.errors?.required">veillez choisir l'heure du sinistre svp
                        </mat-error> 
                        </mat-form-field>
                        
                    </div>
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">  
                    <div fxFlex="100" class="px-3">
                        <h4> 2- NATURE DU SINISTRE</h4><br />
                    </div>
                    <div fxFlex="100" class="px-3">
                        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                            (change)="selected($event) ">
                            <mat-radio-button class="example-radio-button" *ngFor="let season of etats"
                                [value]="season">
                                {{season}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="20"  class="px-3"></div>
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                    <div fxFlex="100" class="px-4">
                        <h3>3- Ajouter les images du vehicule accidenté</h3><br />
                    </div> 
                    <div fxFlex="100" fxFlex.gt-sm="100" class="px-4">
                        <div class="custom-dropzone" ngx-dropzone [accept]="'image/jpeg,image/jpg,image/png,image/gif'"
                        (change)="onSelect($event)">
                            <ngx-dropzone-label>
                                <div>
                                    <button mat-icon-button color="primary">
                                        <mat-icon>file_upload</mat-icon>
                                    </button>
                                    <h4>Veuillez insérer les images du véhicule</h4>
                                    <h4 style="color: red;">La taille du fichier doit être inférieure ou également à 5Mo</h4>
                                </div>
                            </ngx-dropzone-label>
                            <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview"
                                *ngFor="let f of files; let i = index" [file]="f" [removable]="true" (removed)="onRemove(f)">
                                <!-- <ngx-dropzone-label style="margin-top: 176px;">{{ i+1 }}</ngx-dropzone-label> -->
                            </ngx-dropzone-image-preview>
                        </div> 
                    </div>                                  
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">  
                            <div fxFlex="100" class="px-4">
                                <h3>4- Nature des Dégats.</h3>
                            </div>
        
                            <div fxFlex="100" fxFlex.gt-sm="100" class="px-3">
                                <mat-form-field class="example-full-width" appearance="outline" class="w-100">
                                    <mat-label>Nature des Dégats.</mat-label>
                                    <textarea matInput placeholder="Nature_des_Dégats " formControlName="degats_description"
                                        rows="5" required></textarea>
                                    <mat-error *ngIf="Formcar.controls.degats_description.errors?.required">veillez remplir ce champ 
                                    </mat-error>
                                </mat-form-field>                                
                            </div>
                            <mat-divider></mat-divider>
                        </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">  
                            <div fxFlex="100" class="px-4">
                                <h3>5- Decrivez votre accident.</h3>
                            </div>
        
                            <div fxFlex="100" fxFlex.gt-sm="100"  class="px-3">
                                <mat-form-field class="example-full-width" appearance="outline" class="w-100">
                                    <mat-label>Decrivez votre accident.</mat-label>
                                    <textarea matInput placeholder="vehicule_description "
                                        formControlName="sinister_description" rows="5" required></textarea>
                                    <mat-error *ngIf="Formcar.controls.sinister_description.errors?.required">veillez decripre votre sinistre svp
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">  
                   
                    <div fxFlex="100">
                        <h2  fxFlex="100" class="px-4">6- Si un Tiers (autre véhicule ou personne) est impliqué : veuillez
                            fournir les informations d’identification :
                        </h2><br /><br /><br />
                    </div>
                    <i>
                        <h4 fxFlex="100" fxFlex.gt-sm="100" fxFlex.sm="100" class="px-4">a)Concernant proprietaire tier</h4>
                    </i>

                    <div fxFlex="100" fxFlex.gt-sm="100" class="px-2"></div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3" fxFlexAlign="center">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nom , Prenom proprio'</mat-label>
                            <input matInput formControlName="NomPorprio" required>
                            <mat-error *ngIf="Formcar.controls.sinister_description.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Adresse Proprio'</mat-label>
                            <input matInput formControlName="AdresseProprio" required>
                            <mat-error *ngIf="Formcar.controls.AdresseProprio.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nom du conducteur'</mat-label>
                            <input matInput formControlName="NomConducteur" required>
                            <mat-error *ngIf="Formcar.controls.NomConducteur.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Profession Proprio'</mat-label>
                            <input matInput formControlName="ProfessionProprio" required>
                            <mat-error *ngIf="Formcar.controls.ProfessionProprio.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>

                    </div>


                    <h4 fxFlex="100" class="px-4">b)Concernant le tiers</h4>
                 
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Assuré à'</mat-label>
                            <input matInput formControlName="AssureA" required>

                        </mat-form-field>
                       
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>N° de police d'assurance :'</mat-label>
                            <input matInput formControlName="NumPoliceAssurance" required>

                        </mat-form-field>
                        
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nature des degats des vehicules tiers :'</mat-label>
                            <input matInput formControlName="NatureDegatSurVehicule" required>

                        </mat-form-field>
                
                    </div>


                    <div fxFlex="100" fxFlex.gt-sm="10" class="px-3"></div>
                    <h3 fxFlex="70" class="px-4">7- Personne blessé </h3><br />

                    <div class="px-3"></div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nom Prenom Bléssé'</mat-label>
                            <input matInput formControlName="NomPrenomBlesse">
                            <mat-error *ngIf="Formcar.controls.NomPrenomBlesse.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>
                        
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Adresse blesse'</mat-label>
                            <input matInput formControlName="AdresseBlesse">
                            <mat-error *ngIf="Formcar.controls.AdresseBlesse.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>

                        
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nature de la Bléssure :'</mat-label>
                            <input matInput formControlName="NatureBlessure">
                            <mat-error *ngIf="Formcar.controls.NatureBlessure.errors?.required">veillez remplir ce champs svp
                            </mat-error>
                        </mat-form-field>
                       
                    </div>
                    <ng-container formArrayName="lessons">
                        <ng-container *ngFor="let lessonForm of lessons.controls; let i = index" [formGroupName]="i">

                            <div fxFlex="100" fxFlex.gt-sm="10" class="px-3"></div>


                            <h3 fxFlex="70" class="px-4"> Personne blessé </h3><br />
                            <div fxFlex="100" fxFlex.gt-sm="10" class="px-3"></div>

                         
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label> nom prenom blessé:'</mat-label>
                                    <input matInput formControlName="NomPrenomBlesse" placeholder="nom prenom blessé">
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label> Adresse blessé:'</mat-label>
                                    <input matInput formControlName="AdresseBlesse" placeholder="adress hurt">
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">

                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label> Nature Blessure:'</mat-label>
                                    <input matInput formControlName="NatureBlessure" placeholder="NatureBlessure">
                                </mat-form-field>
                            </div>

                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-icon class="delete-btn" (click)="deleteLesson(i)">
                                    delete_forever</mat-icon>
                            </div>


                        </ng-container>
                        <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                            <button type="button" mat-mini-fab (click)="addLesson()">
                                <mat-icon class="add-course-btn">add</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                    <h3 fxFlex="100" class="px-4">8- Témoins </h3><br />
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nom Prenom Temoin'</mat-label>
                            <input matInput formControlName="NomPrenomTemoin" required>
                            <mat-error *ngIf="Formcar.controls.NomPrenomTemoin.errors?.required">veillez remplir ce champs 
                            </mat-error>  
                        </mat-form-field>                          
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Adresse Temoin'</mat-label>
                            <input matInput formControlName="AdresseTemoin" required>
                            <mat-error *ngIf="Formcar.controls.AdresseTemoin.errors?.required">veillez remplir ce champs 
                            </mat-error>
                        </mat-form-field>                        
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Telephone Temoin :'</mat-label>
                            <input  matInput formControlName="TelTemoins" required>
                            <mat-error *ngIf="Formcar.controls.TelTemoins.errors?.required">Champs veillez remplir ce champs 
                            </mat-error>
                            <mat-error *ngIf="Formcar.controls.TelTemoins.errors?.pattern">Ce champs est invalide 
                            </mat-error>
                        </mat-form-field>                       
                    </div>
                    <mat-divider></mat-divider>

                    <ng-container formArrayName="temoin">
                        <ng-container *ngFor="let TemoinsForm of temoin.controls; let i = index" [formGroupName]="i">
                            <h3 fxFlex="100" class="px-4">Témoins </h3>
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <input matInput formControlName="NomPrenomTemoin" placeholder="NomPrenomTemoin">
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <input matInput formControlName="AdresseTemoin" placeholder="AdresseTemoins">
                                </mat-form-field>
                            </div>

                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-form-field appearance="outline" class="w-100">
                                    <input type="number" matInput formControlName="TelTemoins" placeholder="TelTemoins">
                                    <mat-error   *ngIf="temoin.controls[i].get('TelTemoins')?.errors?.partten">veillez remplir ce champs 
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                                <mat-icon class="delete-btn" (click)="deleteTemoin(i)">
                                    delete_forever</mat-icon>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <button type="button" mat-mini-fab (click)="addTemoin()">
                            <mat-icon class="add-course-btn">add</mat-icon>
                        </button>
                    </div>
                </div>
                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                        <h3 fxFlex="100" class="px-4">9- Si rapport d'argent ou PV de gendarmerie ACC7156 </h3>
                        <div fxFlex="100" class="px-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Numéro du Rapport ou du PV</mat-label>
                                <input matInput formControlName="NumRapportPV" required>
                                <mat-error *ngIf="Formcar.controls.NumRapportPV.errors?.required">veillez remplir ce champs 
                                </mat-error>
                            </mat-form-field>                            
                        </div>
                </div>
                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                        <h3 fxFlex="100" class="px-4">10 - Circonstances détaillées </h3>
                        <div fxFlex="100" fxFlex.gt-sm="100" class="px-3">
                            <mat-form-field class="example-full-width" appearance="outline" class="w-100">
                                <mat-label>Circonstances détaillées.</mat-label>
                                <textarea matInput placeholder="vehicule_description (street, apartment, suite, unit etc.)"
                                    formControlName="CirconstanceDetaillees" rows="5" required></textarea>
                                <mat-error *ngIf="Formcar.controls.CirconstanceDetaillees.errors?.required">veillez remplir ce champs 
                                </mat-error>
                            </mat-form-field>                       
                        </div>
                </div>

                <div fxLayout="row wrap" class="flex-wrapper" style="margin-top:20px">
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <div class="text-center">
                            <button (click)="onInfoFormCoordonneesSubmit()" mat-raised-button color="primary"
                                type="submit" class="w-100 uppercase" [disabled]="Formcar.invalid" ><span
                                    class="px-3 uppercase">Enregistrer</span></button>
                        </div>
                    </div>
                    <div class='center' fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <div class="text-center">
                            <button mat-raised-button color="warn" type="button" routerLink="/compte-utilisateur/sinistre" class="w-100 uppercase">
                                <span class="px-3 uppercase">Annuler</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </mat-tab>
</mat-tab-group>